export default __webpack_public_path__ + "static/media/close-icon.8ecb397d.svg";